import { FilterParams } from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import { useFilter } from '@synergy/components';

import { Contact } from '../../models/contact';
import { PoolCustomerContactAutocompleteList } from '../autocomplete-list/customer-contact-autocomplete-list/pool-customer-contact-autocomplete-list';

export const RecipientContactFilter = () => {
    const { filter, getFromCache, updateCache, updateFilter, registerFilterMap } = useFilter();

    const onSelected = (contact: Contact | null) => {
        filter.delete(FilterParams.RecipientContactId);
        if (contact) {
            updateCache(`recipientContact_${contact.id}`, contact?.fullName);
            filter.set(FilterParams.RecipientContactId, contact.id.toString());
        }
        updateFilter(filter);
    };

    const getDisplayValue = (contactId: unknown): string => {
        if (typeof contactId !== 'string') {
            return '';
        }

        return getFromCache(`recipientContact_${contactId}`) as string;
    };

    registerFilterMap(FilterParams.RecipientContactId, getDisplayValue);

    const accountId = filter.get('recipientAccountId') || filter.get('accountId');

    return (
        <PoolCustomerContactAutocompleteList
            onSelected={onSelected}
            label={<FormattedMessage id="app.filter.recipientContact" />}
            required={false}
            initialValue={getDisplayValue(filter.get(FilterParams.RecipientContactId)) ?? ''}
            disablePreventOverflow={true}
            accountId={accountId !== null ? +accountId : undefined}
        />
    );
};
